import React, { createContext, useContext, useState, useEffect } from 'react';
import { DEFAULT_CURRENCY, CURRENCIES, CurrencyConfig, getCurrencyByCode } from '@/config/currency';

interface CurrencyContextType {
  currency: string;
  setCurrency: (code: string) => void;
  currencyConfig: CurrencyConfig;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined);

const CURRENCY_STORAGE_KEY = 'revenueManagerCurrency';

export function CurrencyProvider({ children }: { children: React.ReactNode }) {
  const [currency, setCurrencyState] = useState<string>(() => {
    // Load from localStorage or use default
    const stored = localStorage.getItem(CURRENCY_STORAGE_KEY);
    return stored || DEFAULT_CURRENCY;
  });

  const currencyConfig = getCurrencyByCode(currency) || getCurrencyByCode(DEFAULT_CURRENCY)!;

  const setCurrency = (code: string) => {
    if (CURRENCIES.find(c => c.code === code)) {
      setCurrencyState(code);
      localStorage.setItem(CURRENCY_STORAGE_KEY, code);
    }
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, currencyConfig }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
}
